import axios from "axios";

export const apiInstance = axios.create({
baseURL: "https://www.h2amedics.com/api/v1/"
})



export const UPLOAD_PRESETS_CLOUDINARY = "h2a_medical"
export const CLOUD_NAME = "dihgm0qzr"
export const API_SECRET = "poeMSp-1hyIq_kR3efrk18kq2gY"
